import { Head, Link } from "@inertiajs/react"
import PublicLayout from "@/components/public/layout"
import { ScrollReveal } from "@/components/ui/scroll-reveal"
import type { SeoMeta } from "@/types"

/* ------------------------------------------------------------------ */
/* Inline SVG icons                                                    */
/* ------------------------------------------------------------------ */

function IconSparkles() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
    </svg>
  )
}

function IconShare() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
    </svg>
  )
}

function IconMic() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z" />
    </svg>
  )
}

function IconPalette() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z" />
    </svg>
  )
}

function IconUsers() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
    </svg>
  )
}

/* Portal logos */
function LogoRightmove() {
  return (
    <svg viewBox="0 0 180 40" className="h-8" fill="#005EA8">
      <text x="5" y="28" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="bold">Rightmove</text>
    </svg>
  )
}

function LogoZoopla() {
  return (
    <svg viewBox="0 0 120 40" className="h-8" fill="#7B3FF2">
      <text x="5" y="28" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="bold">Zoopla</text>
    </svg>
  )
}

function LogoOnTheMarket() {
  return (
    <svg viewBox="0 0 220 40" className="h-8" fill="#1E3A8A">
      <text x="5" y="28" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold">OnTheMarket</text>
    </svg>
  )
}

function LogoAirbnb() {
  return (
    <svg viewBox="0 0 120 40" className="h-8" fill="#FF5A5F">
      <text x="5" y="28" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="bold">Airbnb</text>
    </svg>
  )
}

function LogoBooking() {
  return (
    <svg viewBox="0 0 200 40" className="h-8" fill="#003580">
      <text x="5" y="28" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold">Booking.com</text>
    </svg>
  )
}

function IconShield() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
    </svg>
  )
}

function IconBolt() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
    </svg>
  )
}

function IconRectangleGroup() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z" />
    </svg>
  )
}

function IconMusic() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z" />
    </svg>
  )
}

function IconGlobe() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5a17.92 17.92 0 0 1-8.716-2.247m0 0A8.966 8.966 0 0 1 3 12c0-1.264.26-2.467.732-3.559" />
    </svg>
  )
}

function IconTrophy() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M18.75 4.236c.982.143 1.954.317 2.916.52A6.003 6.003 0 0 1 16.27 9.728M18.75 4.236V4.5c0 2.108-.966 3.99-2.48 5.228m0 0a6.023 6.023 0 0 1-2.77.853m0 0a5.96 5.96 0 0 1-1 .084m1-.084a5.96 5.96 0 0 0 .981-3.172M10.478 14.25a5.96 5.96 0 0 0 1-.084m-1 .084a5.96 5.96 0 0 1-.981-3.172" />
    </svg>
  )
}

function IconClock() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  )
}

function IconChart() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941" />
    </svg>
  )
}

/* ------------------------------------------------------------------ */
/* Visual mock components                                              */
/* ------------------------------------------------------------------ */

function MockScraperUI() {
  return (
    <div className="overflow-hidden rounded-lg border border-stone shadow-sm">
      <div className="flex items-center gap-2 rounded-t-lg border-b border-stone bg-white px-4 py-2.5">
        <div className="flex gap-1.5">
          <div className="size-3 rounded-full bg-stone" />
          <div className="size-3 rounded-full bg-stone" />
          <div className="size-3 rounded-full bg-stone" />
        </div>
        <div className="ml-3 flex-1 rounded-md bg-cream px-3 py-1 text-xs text-warm-grey">rightmove.co.uk/properties/156482937</div>
      </div>
      <div className="bg-white p-5">
        <div className="flex gap-3">
          <div className="w-1/2 space-y-2">
            <div className="aspect-[4/3] rounded bg-stone/50" />
            <div className="grid grid-cols-3 gap-1">
              {[1, 2, 3].map((i) => (
                <div key={i} className="aspect-square rounded bg-stone/30" />
              ))}
            </div>
          </div>
          <div className="w-1/2 space-y-2">
            <div className="h-4 w-3/4 rounded bg-charcoal/70" />
            <div className="h-3 w-1/2 rounded bg-stone/60" />
            <div className="mt-3 flex gap-4">
              <div className="flex items-center gap-1">
                <div className="size-4 rounded bg-stone/40" />
                <div className="h-3 w-6 rounded bg-stone/40" />
              </div>
              <div className="flex items-center gap-1">
                <div className="size-4 rounded bg-stone/40" />
                <div className="h-3 w-6 rounded bg-stone/40" />
              </div>
            </div>
            <div className="mt-2 h-3 w-full rounded bg-stone/30" />
            <div className="h-3 w-full rounded bg-stone/30" />
            <div className="h-3 w-2/3 rounded bg-stone/30" />
            <div className="mt-3 flex flex-wrap gap-1.5">
              {["Garden", "Parking", "Period"].map((f) => (
                <span key={f} className="rounded-full bg-cream px-2 py-0.5 text-[10px] text-slate">{f}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-3 flex items-center gap-2">
          <div className="size-2 rounded-full bg-green-500 animate-pulse" />
          <p className="text-[11px] text-green-700">12 photos imported · Data extracted successfully</p>
        </div>
      </div>
    </div>
  )
}

function MockScriptUI() {
  return (
    <div className="overflow-hidden rounded-lg border border-stone shadow-sm">
      <div className="flex items-center justify-between border-b border-stone bg-white px-4 py-2.5">
        <p className="text-xs font-medium text-charcoal">Video script</p>
        <div className="flex gap-1.5">
          <span className="rounded bg-cream px-2 py-0.5 text-[10px] text-slate">Regenerate</span>
          <span className="rounded bg-red px-2 py-0.5 text-[10px] text-white">Approve</span>
        </div>
      </div>
      <div className="bg-white p-5 space-y-3">
        <div>
          <p className="text-[10px] font-medium uppercase tracking-wider text-warm-grey">Headline</p>
          <p className="mt-1 font-display text-sm font-semibold text-charcoal italic">&ldquo;Georgian grandeur in the heart of Clifton&rdquo;</p>
        </div>
        <div className="space-y-2">
          <p className="text-[10px] font-medium uppercase tracking-wider text-warm-grey">Scenes</p>
          {[
            { text: "Step inside this stunning five-bedroom home", time: "3s" },
            { text: "A Georgian kitchen with period details", time: "3s" },
            { text: "Sweeping views across the Avon Gorge", time: "3s" },
          ].map((scene, i) => (
            <div key={i} className="flex items-start gap-2 rounded border border-stone/60 px-3 py-2">
              <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-red/10 text-[10px] font-semibold text-red">{i + 1}</span>
              <div className="flex-1">
                <p className="text-xs text-charcoal">{scene.text}</p>
              </div>
              <span className="text-[10px] text-warm-grey">{scene.time}</span>
            </div>
          ))}
        </div>
        <div>
          <p className="text-[10px] font-medium uppercase tracking-wider text-warm-grey">Call to action</p>
          <p className="mt-1 text-xs text-charcoal font-medium">&ldquo;Book a viewing&rdquo;</p>
        </div>
      </div>
    </div>
  )
}

function MockTemplateUI() {
  return (
    <div className="overflow-hidden rounded-lg border border-stone shadow-sm">
      <div className="border-b border-stone bg-white px-4 py-2.5">
        <p className="text-xs font-medium text-charcoal">Choose a template</p>
      </div>
      <div className="bg-white p-5">
        <div className="grid grid-cols-2 gap-3">
          {[
            { name: "Classic", gradient: "from-amber-700 to-stone-600", accent: "bg-red", active: true },
            { name: "Modern", gradient: "from-zinc-600 to-zinc-800", accent: "bg-charcoal", active: false },
            { name: "Prestige", gradient: "from-emerald-800 to-stone-700", accent: "bg-gold", active: false },
            { name: "Bold", gradient: "from-orange-700 to-red-800", accent: "bg-slate", active: false },
          ].map((t) => (
            <div
              key={t.name}
              className={`overflow-hidden rounded-lg border ${t.active ? "border-red ring-2 ring-red/20" : "border-stone"}`}
            >
              <div className={`aspect-[9/16] w-full bg-gradient-to-b ${t.gradient} relative`}>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-2">
                  <div className="h-1.5 w-10 rounded bg-white/70" />
                  <div className="mt-1 h-1 w-7 rounded bg-white/40" />
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="flex size-6 items-center justify-center rounded-full bg-white/20">
                    <svg viewBox="0 0 24 24" fill="white" className="ml-0.5 size-3">
                      <path d="M8 5.14v14l11-7-11-7z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-2 py-1.5">
                <div className={`size-2 rounded-full ${t.accent}`} />
                <span className={`text-[11px] font-medium ${t.active ? "text-charcoal" : "text-warm-grey"}`}>{t.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function MockPublishUI() {
  return (
    <div className="overflow-hidden rounded-lg border border-stone shadow-sm">
      <div className="border-b border-stone bg-white px-4 py-2.5">
        <p className="text-xs font-medium text-charcoal">Publish video</p>
      </div>
      <div className="bg-white p-5 space-y-2.5">
        {[
          { platform: "Instagram Reels", colour: "bg-gradient-to-r from-purple-500 to-pink-500", caption: "Stunning 5-bed on Royal York Crescent, Clifton... #property" },
          { platform: "TikTok", colour: "bg-charcoal", caption: "Wait until you see the gorge views" },
          { platform: "YouTube Shorts", colour: "bg-red-600", caption: "8 Royal York Crescent, Clifton - Virtual tour" },
          { platform: "Facebook", colour: "bg-blue-600", caption: "New to market: a beautifully presented five-bedroom home..." },
          { platform: "LinkedIn", colour: "bg-blue-700", caption: "New to market: a beautifully presented home in Clifton..." },
        ].map((p) => (
          <div key={p.platform} className="rounded-md border border-stone p-2.5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className={`size-2.5 rounded-sm ${p.colour}`} />
                <span className="text-xs font-medium text-charcoal">{p.platform}</span>
              </div>
              <span className="rounded bg-red px-2 py-0.5 text-[10px] font-medium text-white">Post</span>
            </div>
            <p className="mt-1.5 text-[11px] text-warm-grey truncate">{p.caption}</p>
          </div>
        ))}
        <p className="text-center text-[10px] text-warm-grey pt-1">Captions are written for each platform automatically</p>
      </div>
    </div>
  )
}

/* ------------------------------------------------------------------ */
/* Page component                                                      */
/* ------------------------------------------------------------------ */

export default function Features({ meta }: { meta: SeoMeta }) {
  return (
    <PublicLayout>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={meta.canonical} />

        {/* Open Graph */}
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={meta.canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={meta.image} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />

        {/* Structured Data — SoftwareApplication */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "QuiteRight",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web",
            description: meta.description,
            url: meta.canonical,
            offers: {
              "@type": "Offer",
              price: "49",
              priceCurrency: "GBP",
            },
          })}
        </script>
      </Head>

      {/* Hero — lead with outcome, not toolset */}
      <section className="px-6 py-24 md:py-32">
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Features</p>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-charcoal sm:text-5xl md:text-6xl">
            More instructions. Faster sales. Less work<span className="text-red">.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-slate">
            Every feature in QuiteRight exists for one reason: to help you win more
            business. Professional video marketing that makes you the obvious choice
            when vendors are picking an agent.
          </p>
          <div className="mx-auto mt-10 flex max-w-xl flex-wrap items-center justify-center gap-4">
            {[
              { icon: IconTrophy, label: "Win instructions" },
              { icon: IconClock, label: "Save hours" },
              { icon: IconChart, label: "Sell faster" },
              { icon: IconShare, label: "Be everywhere" },
              { icon: IconPalette, label: "Your brand" },
              { icon: IconShield, label: "Zero risk" },
            ].map((f) => {
              const Icon = f.icon
              return (
                <div key={f.label} className="flex items-center gap-2 rounded-full border border-stone bg-white px-3.5 py-2">
                  <span className="text-red"><Icon /></span>
                  <span className="text-sm font-medium text-charcoal">{f.label}</span>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Feature 1: Listing import — save hours */}
      <section className="border-t border-stone bg-white px-6 py-20">
        <ScrollReveal className="mx-auto max-w-6xl">
          <div className="flex flex-col items-center gap-12 md:flex-row md:gap-16">
            <div className="flex-1">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Save hours every week</p>
              <h2 className="mt-3 font-display text-3xl font-bold text-charcoal md:text-4xl">
                Your listing becomes a video in 60 seconds<span className="text-red">.</span>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate">
                While your competitors are calling videographers and waiting days for edits,
                you paste a Rightmove URL and have a finished video before your coffee goes cold.
                Every photo, every detail, extracted automatically.
              </p>
              <div className="mt-8 space-y-4">
                {[
                  { icon: IconBolt, title: "Minutes, not days", description: "A videographer takes a week. You take 60 seconds. That listing goes live with video while others are still scheduling the shoot." },
                  { icon: IconGlobe, title: "Every major portal", description: "Rightmove, Zoopla, OnTheMarket, Airbnb, and Booking.com. One URL gives you everything - photos, data, features." },
                  { icon: IconRectangleGroup, title: "No manual work", description: "No copy-pasting, no spreadsheets, no re-typing addresses. The listing data is extracted and ready to go." },
                ].map((f) => {
                  const Icon = f.icon
                  return (
                    <div key={f.title} className="flex gap-3">
                      <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-red/10 text-red"><Icon /></span>
                      <div>
                        <p className="text-sm font-semibold text-charcoal">{f.title}</p>
                        <p className="text-sm text-slate">{f.description}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="w-full max-w-md flex-1">
              <MockScraperUI />
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* Feature 2: Scripts + voiceover — no copywriter needed */}
      <section className="border-t border-stone px-6 py-20">
        <ScrollReveal className="mx-auto max-w-6xl">
          <div className="flex flex-col items-center gap-12 md:flex-row-reverse md:gap-16">
            <div className="flex-1">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Impress every vendor</p>
              <h2 className="mt-3 font-display text-3xl font-bold text-charcoal md:text-4xl">
                Agency-quality marketing without the agency cost<span className="text-red">.</span>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate">
                A professional script, a polished British voiceover, and background music that
                sets the mood - all generated from your listing in seconds. Show vendors
                you&rsquo;re serious about marketing their property, without hiring a copywriter
                or a voice artist.
              </p>
              <div className="mt-8 space-y-4">
                {[
                  { icon: IconSparkles, title: "Scripts that sell", description: "Property-specific scripts that highlight the features buyers actually care about. Review, tweak, or regenerate until it's perfect." },
                  { icon: IconMic, title: "Professional voiceover", description: "Curated British voices bring every listing to life. The kind of voiceover that makes a vendor think: 'this agent is different.'" },
                  { icon: IconMusic, title: "The right mood", description: "Royalty-free music in three moods - upbeat, elegant, and minimal. The finishing touch that turns a good video into a great one." },
                ].map((f) => {
                  const Icon = f.icon
                  return (
                    <div key={f.title} className="flex gap-3">
                      <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-red/10 text-red"><Icon /></span>
                      <div>
                        <p className="text-sm font-semibold text-charcoal">{f.title}</p>
                        <p className="text-sm text-slate">{f.description}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="w-full max-w-md flex-1">
              <MockScriptUI />
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* Feature 3: Video templates — stand out */}
      <section className="border-t border-stone bg-white px-6 py-20">
        <ScrollReveal className="mx-auto max-w-6xl">
          <div className="flex flex-col items-center gap-12 md:flex-row md:gap-16">
            <div className="flex-1">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Stand out from every competitor</p>
              <h2 className="mt-3 font-display text-3xl font-bold text-charcoal md:text-4xl">
                Match the video to the property and the buyer<span className="text-red">.</span>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate">
                A luxury townhouse needs a different feel from a first-time-buyer flat. Four
                distinctive templates let you match the video to the property - and the
                audience. The vendor sees a premium marketing package. The buyer sees a
                property they can&rsquo;t scroll past.
              </p>
              <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {[
                  { name: "Classic", desc: "The trusted all-rounder for most listings", colour: "border-l-red" },
                  { name: "Modern", desc: "Bold presence for urban and new-build properties", colour: "border-l-charcoal" },
                  { name: "Prestige", desc: "Luxury feel for premium instructions", colour: "border-l-gold" },
                  { name: "Bold", desc: "High energy for investment and FTB properties", colour: "border-l-slate" },
                ].map((t) => (
                  <div key={t.name} className={`rounded-md border border-stone border-l-4 ${t.colour} bg-cream px-3 py-2.5`}>
                    <p className="text-sm font-semibold text-charcoal">{t.name}</p>
                    <p className="text-xs text-slate">{t.desc}</p>
                  </div>
                ))}
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-6 text-sm text-slate">
                {["Portrait (9:16)", "Landscape (16:9)", "Square (1:1)"].map((format) => (
                  <div key={format} className="flex items-center gap-1.5">
                    <svg viewBox="0 0 20 20" fill="#C41E2A" className="size-4">
                      <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" />
                    </svg>
                    <span>{format}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full max-w-sm flex-1">
              <MockTemplateUI />
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* Feature 4: Social publishing — be everywhere */}
      <section className="border-t border-stone px-6 py-20">
        <ScrollReveal className="mx-auto max-w-6xl">
          <div className="flex flex-col items-center gap-12 md:flex-row-reverse md:gap-16">
            <div className="flex-1">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Be the most visible agent in your area</p>
              <h2 className="mt-3 font-display text-3xl font-bold text-charcoal md:text-4xl">
                One click. Five platforms. Every buyer sees you<span className="text-red">.</span>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate">
                Buyers are on Instagram. Landlords are on LinkedIn. First-time buyers
                are on TikTok. You need to be on all of them - and with QuiteRight, you
                are. One click publishes your video everywhere, with captions written
                for each platform.
              </p>
              <div className="mt-8 space-y-4">
                {[
                  { icon: IconShare, title: "Reach every buyer type", description: "Instagram Reels for local buyers. TikTok for younger audiences. YouTube Shorts for search. Facebook for families. LinkedIn for investors and landlords." },
                  { icon: IconSparkles, title: "Captions that convert", description: "Platform-specific captions with the right hashtags, the right tone, and the right length. No rewriting for each channel." },
                  { icon: IconRectangleGroup, title: "Always the right format", description: "Portrait for Reels and TikTok. Landscape for YouTube. Square for feeds. The right format renders automatically." },
                ].map((f) => {
                  const Icon = f.icon
                  return (
                    <div key={f.title} className="flex gap-3">
                      <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-red/10 text-red"><Icon /></span>
                      <div>
                        <p className="text-sm font-semibold text-charcoal">{f.title}</p>
                        <p className="text-sm text-slate">{f.description}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="w-full max-w-md flex-1">
              <MockPublishUI />
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* Feature 5: Team + branding — your brand, your glory */}
      <section className="border-t border-stone bg-charcoal px-6 py-20">
        <div className="mx-auto max-w-5xl">
          <div className="text-center">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-red">Your brand front and centre</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-cream md:text-4xl">
              Vendors see a premium agency. Not a tech tool<span className="text-red">.</span>
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-warm-grey">
              Every video carries your name, your logo, and your colours. When a vendor
              watches the video in their market appraisal, they see a polished agency
              with a serious marketing offering - and that&rsquo;s exactly what wins the instruction.
            </p>
          </div>
          <ScrollReveal stagger className="mt-12 grid gap-6 md:grid-cols-3">
            {[
              {
                icon: IconPalette,
                title: "Your brand on every video",
                description: "Name, logo, and brand colours on every video you create. Clients see your brand, not ours. That's the whole point.",
              },
              {
                icon: IconUsers,
                title: "Built for multi-branch agencies",
                description: "Invite your team. Share listings, social connections, and brand settings across branches - one subscription, one account.",
              },
              {
                icon: IconShield,
                title: "Control who does what",
                description: "Owners, admins, and members. Control who connects socials, manages billing, and publishes videos. Keep your brand consistent.",
              },
            ].map((f) => {
              const Icon = f.icon
              return (
                <div key={f.title} className="rounded-lg border border-slate bg-charcoal p-6">
                  <span className="flex size-10 items-center justify-center rounded-lg bg-red/10 text-red"><Icon /></span>
                  <h3 className="mt-4 font-display text-lg font-semibold text-cream">{f.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-warm-grey">{f.description}</p>
                </div>
              )
            })}
          </ScrollReveal>
        </div>
      </section>

      {/* Portal support — not a feature, it's compatibility */}
      <section className="border-t border-stone bg-white px-6 py-20">
        <div className="mx-auto max-w-5xl">
          <h2 className="text-center font-display text-3xl font-bold text-charcoal">
            Works with the portals you already use<span className="text-red">.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-base text-slate">
            No new tools to learn. No extra admin. Just paste the URL from any of these portals.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
            {[
              { name: "Rightmove", url: "https://www.rightmove.co.uk", Logo: LogoRightmove },
              { name: "Zoopla", url: "https://www.zoopla.co.uk", Logo: LogoZoopla },
              { name: "OnTheMarket", url: "https://www.onthemarket.com", Logo: LogoOnTheMarket },
              { name: "Airbnb", url: "https://www.airbnb.co.uk", Logo: LogoAirbnb },
              { name: "Booking.com", url: "https://www.booking.com", Logo: LogoBooking },
            ].map((portal) => (
              <a
                key={portal.name}
                href={portal.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group opacity-60 transition-opacity hover:opacity-100"
                title={`Visit ${portal.name}`}
              >
                <portal.Logo />
              </a>
            ))}
          </div>
          <div className="mt-8 text-center">
            <p className="text-sm text-warm-grey">
              Don&rsquo;t see yours? You can always enter listing details manually.
            </p>
          </div>
        </div>
      </section>

      {/* The business case — stats that matter to agents */}
      <section className="border-t border-stone px-6 py-16">
        <div className="mx-auto max-w-5xl">
          <h2 className="mb-12 text-center font-display text-3xl font-bold text-charcoal md:text-4xl">
            The numbers that matter<span className="text-red">.</span>
          </h2>
          <ScrollReveal stagger className="grid gap-8 md:grid-cols-4">
            {[
              { stat: "60s", label: "From listing to finished video" },
              { stat: "5x", label: "More engagement than static photos" },
              { stat: "73%", label: "Of vendors prefer agents who use video" },
              { stat: "1 click", label: "To publish across five platforms" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <p className="font-display text-3xl font-bold text-red">{s.stat}</p>
                <p className="mt-1 text-sm text-slate">{s.label}</p>
              </div>
            ))}
          </ScrollReveal>
        </div>
      </section>

      {/* CTA — business-focused */}
      <section className="border-t border-stone px-6 py-24">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-display text-3xl font-bold text-charcoal md:text-4xl">
            Your next vendor will ask: &ldquo;Do you do video?&rdquo;<span className="text-red" />
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-slate">
            Make sure the answer is yes. Start free - your first video is on us.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              href="/demo"
              className="inline-flex w-full items-center justify-center rounded-md bg-red px-6 py-3 text-base font-medium text-white transition-colors hover:bg-deep-red sm:w-auto"
            >
              See it work with your listings
            </Link>
            <Link
              href="/examples"
              className="inline-flex w-full items-center justify-center rounded-md border border-stone bg-white px-6 py-3 text-base font-medium text-charcoal transition-colors hover:bg-stone sm:w-auto"
            >
              Watch real property videos
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  )
}
